import { cn } from "@/lib/utils";

const COLORS = [
  "bg-stone-200 text-stone-700",
  "bg-orange-100 text-orange-700",
  "bg-emerald-100 text-emerald-700",
  "bg-sky-100 text-sky-700",
  "bg-violet-100 text-violet-700",
  "bg-rose-100 text-rose-700",
  "bg-amber-100 text-amber-800",
];

export function getInitials(name) {
  if (!name) return "?";
  const parts = name.trim().split(/\s+/);
  if (parts.length === 1) return parts[0].slice(0, 2).toUpperCase();
  return (parts[0][0] + parts[parts.length - 1][0]).toUpperCase();
}

function hashStr(s) {
  let h = 0;
  for (let i = 0; i < (s || "").length; i++) h = (h * 31 + s.charCodeAt(i)) | 0;
  return Math.abs(h);
}

export function InitialsAvatar({ name, size = "md", className }) {
  const initials = getInitials(name);
  const color = COLORS[hashStr(name) % COLORS.length];
  const sizeClass = {
    xs: "h-6 w-6 text-[10px]",
    sm: "h-8 w-8 text-xs",
    md: "h-10 w-10 text-sm",
    lg: "h-14 w-14 text-base",
  }[size];

  return (
    <div
      className={cn(
        "inline-flex items-center justify-center rounded-full font-medium select-none",
        sizeClass,
        color,
        className,
      )}
      data-testid="initials-avatar"
    >
      {initials}
    </div>
  );
}
